import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import Button from '../../components/UI/Button/Button';
import AttachFilePreview from '../AttachFile/AttachFilePreview';
import Icon from '../../components/UI/Icon/Icon';
import './CvUpload.css';
import MediaQuery from 'react-responsive';
import errorIcon from'../../assets/images/red-alert.svg';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';
import * as actions from '../../store/actions/index';

class CvUpload extends Component {
  state = {
    fileList: [],
    errorMessage:'',
    btnDisable: false,
  };

  componentWillMount() {
    const NewFileList = this.props.selectedFiles ? this.props.selectedFiles.split(';') : '';
    if(NewFileList.length) {
      let files = [];
      NewFileList.map((file, index) => {
        files[index] = {};
        files[index].name = file.split('/')[1];
      });
      this.setState({fileList:files});
    }
  }

  componentDidMount(){
    if(this.props.uploadButtonStatus){
      this.setState({btnDisable: this.props.uploadButtonStatus});
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.uploadButtonStatus !== prevProps.uploadButtonStatus){
      this.setState({btnDisable: this.props.uploadButtonStatus});
    }
  }

  componentUpdate(nextProps) {
    // ConsoleLog("componentupdate",)
    // if (this.props.fileList) {
    //     this.setState({fileList:[]});
    // }
  }


  /**
  * @desc handling draging file in file upload
  * @param event
  * @return null
  */
  handleDragOver = (e) =>  {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const hoverState = (e.type === 'dragover') ? "hover" : null;
    this.setState({
      hoverState
    })
  }

  /**
  * @desc handling file select event in file upload
  * @param event
  * @return null
  */
  handleFileSelect = (e) => { ConsoleLog('file selected');
    this.props.setUploadButton(true);
    this.handleDragOver(e);
    ConsoleLog("this.props.id",this.props.id)
    let files = e.target.files || e.dataTransfer.files;
    ConsoleLog("files",files)
    if(this.props.fileList){
        this.setState({fileList:[]});
    }
    let fileList = [...this.state.fileList];
    let fileNames = fileList.map(file=> {return file.name})
    let NewFileList = Object.keys(files).map(file => files[file]); 
    ConsoleLog("NewFileList",NewFileList)
    let errorMessage = "";
    if(this.props.id){
        NewFileList.map(file=>{
          ConsoleLog('inside', this.props.id, file.name);
            if(file.name.indexOf(this.props.id) == -1){
                errorMessage = "CV file name doesn't match given Bullhorn ID";
                this.props.setUploadButton(false);
            }
           else if(file && (file.size > this.props.maxSize)) {
            errorMessage = "File size exceeded.";
            this.props.setUploadButton(false);
            }
            else if(fileNames.includes(file.name)) {
            errorMessage = "File already exists.";
            this.props.setUploadButton(false);
            }
            else if(!this.props.DragAcceptedTypes.includes(file.type)) {
            errorMessage = "Please select valid file format.";
            this.props.setUploadButton(false);
            }
            else {
            fileList =  fileList.concat(file);
            //ConsoleLog("fileList",fileList)
            this.props.handleFileSelect(file);
            }     
        })}
        else{
            errorMessage='Please Enter valid Bullhorn Id';
        }
    this.setState({
      fileList,
      errorMessage
    });
  }

  /**
  * @desc Removing the selected file.
  * @param index
  * @return null
  */
  removeItem = (index) => {
    //ConsoleLog("removeItem",index,this.state.fileList)
    let fileList = this.state.fileList;
    let file = (fileList.length)? fileList[index].name : null;
    fileList.splice(index,1);
    this.props.handleFileRemove(file);
    this.setState({
      fileList
    });
    this.props.setUploadButton(false);
  }

  removeFile = ()=> {
     ConsoleLog("removeFile",this.state)
    this.setState({
      fileList:[]
    });
  }

  /**
  * @desc preview for the file upload.
  * @param null
  * @return null
  */
  previews = () => {
    return this.state.fileList.map((file, index) => {
        ConsoleLog('previews progress',this.props.selectedFiles,"filename",file.name)
      const isUploadedFile = this.props.selectedFiles.includes(file.name);
      return (
        <AttachFilePreview key={index} data={file} onRemove={()=>this.removeItem(index)} progressPercent={this.props.progressPercent} isUploadedFile={isUploadedFile}/>
      );
    });
  
  }

  /**
  * @desc Selecting the file to be uploaded
  * @param event
  * @return null
  */
  selectFile = (e) => {
    e.preventDefault();
    this.input.click(e);
    this.props.onclickAttach();
    //this.setState({ btnDisable: true});
  }

  /**
  * @desc Rendering the DOM element 
  * @param null
  * @return DOM element
  */
  render() {
    let {
      maxSize,
      name,
      multiple,
      label,
      acceptedTypes,
      buttonText,
      dropZoneText,
      disabled,
      className,errorPropsMessage
    } = this.props;

    const { btnDisable } = this.state;
    
    let value = disabled;
    if(btnDisable){
      value = true;
    }
    
    return (
      <div className="cv-file-container">
          <input type='hidden' name={`${name}:maxSize`} value={maxSize} />
          <div className="candidate-cv-upload-section">          
            <div className="upload-button-input">
              <input 
                type='file'
                tabIndex='-1'
                ref={x => this.input = x}
                className="input-file-upload"
                name={name} 
                multiple={multiple}
                size={maxSize}
                accept={acceptedTypes}
                onChange={this.handleFileSelect}
                onClick={(e)=> { e.target.value = null }}/>

              <Button 
                className={disabled?"attach-file-button disabled":"attach-file-button"}
                type='button'
                onClick={this.selectFile}
                disabled={value}>
                {buttonText}
              </Button>
              <span className="dropzone-info">Max file size should be 5MB <br></br> File types should be .doc, .docx, .pdf, .txt</span>

           {this.state.errorMessage? 
             <div className="attach-file-error">
                <div className="toast-icon"><img src={errorIcon}/></div>
                <div className="toast-message">{this.state.errorMessage}</div>
             </div> 
            :""}
             {ConsoleLog('vals', this.props.fileUploaded, this.state.fileList.length)}
             {this.props.fileUploaded && this.state.fileList.length ? this.removeFile() : <div className="dropzone-preview">{this.previews()}</div>}

            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  state: state.cognito.state,
  user: state.cognito.user,
  clientDetails: state.clientProfile.clientDetails,
  groups: state.cognito.groups,  
  userImageSignedUrl: state.clientProfile.userImageSignedUrl,
  interviewListCount: state.clientProfile.interviewListCount,
  uploadButtonStatus: state.clientProfile.uploadButtonStatus
});

const mapDispatchToProps = dispatch => {
  return {
    onUpdateProfileImage: (userImageUrl, loggedInUser) => dispatch(actions.getProfileImage(userImageUrl, loggedInUser)),
    setUploadButton: (status) => dispatch(actions.setUploadButton(status))
      }
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps, null, { pure: false });

export default reduxConnector(withRouter(CvUpload));

//export default CvUpload;


// WEBPACK FOOTER //
// ./src/hoc/CvParsing/CvUpload.js